import React from 'react';
import { useIntl } from 'react-intl';
import { FreeSlot } from '../../../types/FreeSlot';
import { formatTime } from '../../../utils/formatDateAndTime';
import classes from '../classes.module.css';

const Timeslot: React.FC<{ handleSelect: () => void; slot: FreeSlot }> = ({ slot, handleSelect }) => {
  const intl = useIntl();
  return (
    <>
      <input
        type='radio'
        id={slot.startDateTime.toString()}
        name='Time selection'
        value={slot.startDateTime.toString()}
      />
      <label
        className={classes.timeButton}
        htmlFor={slot.startDateTime.toString()}
        onClick={handleSelect}
        onKeyPress={handleSelect}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
        role='button'
        tabIndex={0}
        aria-pressed='false'
      >
        <span>{formatTime(intl.locale, slot.startDateTime)}</span>
      </label>
    </>
  );
};

Timeslot.displayName = 'Timeslot';

export default Timeslot;
